import dayjs from 'dayjs';
import { AgendaSchema, NewAgenda } from '../models';
import { useNotification } from '@/hooks';
import {
  useCreateAgendaMutation,
  useDeleteAgendaMutation,
} from '../services/agendas.services';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { extractDate } from '@/utils';

const useAgendasActions = () => {
  const [createAgenda, { isLoading: isCreatingAgenda }] =
    useCreateAgendaMutation();

  const [deleteAgenda, { isLoading: isDeletingAgenda }] =
    useDeleteAgendaMutation();

  const { showNotification } = useNotification();

  const handleCreateAgenda = async (data: AgendaSchema, reset: () => void) => {
    const formattedData: NewAgenda = {
      dateOpen: dayjs(data.dateOpen).format('YYYY-MM-DD'),
      startHour: data.startHour?.getHours(),
      endHour: data.endHour?.getHours(),
    };

    try {
      const newAgenda = await createAgenda(formattedData).unwrap();
      const numberOfNewSlots = newAgenda.slots.count;
      const message =
        numberOfNewSlots === 0
          ? `No se añadieron nuevos horarios para el ${formattedData.dateOpen}, ya están incluidos.`
          : `Se añadieron ${numberOfNewSlots} nuevos horarios para el ${extractDate(data.dateOpen)}, desde ${formattedData.startHour} hasta ${formattedData.endHour}.`;
      showNotification(message, NotificationSeverity.success);
      reset();
    } catch (error: any) {
      console.error(error);
      showNotification(
        'Ocurrió un error al crear una agenda. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
      throw new Error(error.message);
    }
  };

  const handleDeleteAgenda = async (agendaId: string) => {
    try {
      await deleteAgenda(agendaId).unwrap();
      showNotification(
        'Agenda eliminada correctamente',
        NotificationSeverity.success
      );
    } catch (error) {
      console.error(error);
      showNotification(
        'Ocurrió un error al eliminar una agenda. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    handleCreateAgenda,
    isCreatingAgenda,
    handleDeleteAgenda,
    isDeletingAgenda,
  };
};

export default useAgendasActions;
